import React, {useState,useEffect} from 'react'
import './ButtonAsLink.css'

export default function ButtonAsLink({btnName, isLoginState, isLoginFunct}) {
    return (
        <button className='buttonAsLink cursorPointer' onClick={()=>{isLoginFunct(isLoginState) }}>{btnName}</button>
    )
}